declare namespace $ {

	type $shm_listener__shm_hitalama_map_overlayed_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_overlayed['pointerdown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_overlayed_2 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_overlayed['pointermove_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	export class $shm_hitalama_map_overlayed extends $shm_hitalama_map_page {
		pointerdown_handler( ): any
		pointerdown_listener( ): $shm_listener
		pointermove_handler( ): any
		pointermove_listener( ): $shm_listener
		camera_locked( ): boolean
		overlayed( ): boolean
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=overlayed.view.tree.d.ts.map